import { captureException } from '@sentry/vue'

export function sentryCaptureException (exception: any) {
  return captureException(exception)
}
